import { render, staticRenderFns } from "./IpadModal.vue?vue&type=template&id=a820ee5c&scoped=true&"
import script from "./IpadModal.vue?vue&type=script&lang=js&"
export * from "./IpadModal.vue?vue&type=script&lang=js&"
import style0 from "./IpadModal.vue?vue&type=style&index=0&id=a820ee5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a820ee5c",
  null
  
)

export default component.exports